<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-label class="text-component mb-3">
          Arrastra las tarjetas para asignar la prioridad a los transportistas seleccionados
        </v-label>
      </v-col>
    </v-row>

    <v-row>
      <v-col 
        cols="4" 
        v-for="(quotation, index) in prioritizedQuotations" 
        :key="index"
      >
        <v-card 
          class="pa-4 draggable-card custom-card" 
          elevation="2"
          draggable="true"
          @dragstart="onDragStart($event, index)"
          @dragover.prevent="onDragOver($event, index)"
          @dragenter.prevent="onDragEnter($event, index)"
          @dragleave="onDragLeave($event)"
          @drop="onDrop($event, index)"
          @dragend="onDragEnd"
          :class="{ 'drag-over': dragOverIndex === index, 'dragging': draggingIndex === index }"
        >
          <div class="d-flex align-items-center mb-3 justify-content-between">
            <v-chip 
              :color="getPriorityColor(index)" 
              size="small"
            >
              {{ getPriorityLabel(index) }}
            </v-chip>
            <v-icon class="drag-handle" size="large">mdi-drag-vertical</v-icon>
          </div>
          
          <div class="d-flex flex-column align-items-center">
            <v-avatar 
              color="surface-variant" 
              size="80" 
              :image="quotation.logistic?.profile_picture_url || quotation.idriver?.profile_picture_url"
              class="mb-3"
            ></v-avatar>
            
            <v-label class="title-card-fee mb-2 text-center">
              {{ quotation.logistic != null ? quotation.logistic.name : quotation.idriver != null ? quotation.idriver.name : "" }}
            </v-label>
            
            <v-label class="title-card-fee text-center">
              <strong>{{formatUtils.formatPrice(quotation.price)}}</strong>
            </v-label>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12">
        <v-alert type="info" variant="tonal">
          <strong>Titular:</strong> Transportista principal que recibirá la orden.<br>
          <strong>Suplente 1 y 2:</strong> Transportistas alternativos en caso de que el titular no acepte la orden de envio. <br/>
          En el caso de que la orden no sea aceptada por ningun transportista, se debera crear una nueva cotizacion.
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
  mixins: [ValidMixin],
  components: {},
  props: {
    selectedQuotations: Array,
  },
  data() {
    return {
      formatUtils: formatUtils,
      prioritizedQuotations: [],
      draggingIndex: null,
      dragOverIndex: null,
    };
  },
  watch: {
    selectedQuotations: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          // Inicializar el array priorizado solo si está vacío
          if (this.prioritizedQuotations.length === 0) {
            this.prioritizedQuotations = [...newVal];
          }
        }
      }
    },
    prioritizedQuotations: {
      deep: true,
      handler(newVal) {
        // Emitir el cambio de prioridades al componente padre
        this.$emit('updatePriorities', newVal);
      }
    }
  },
  methods: {
    getPriorityLabel(index) {
      const labels = ['Titular', 'Suplente 1', 'Suplente 2'];
      return labels[index] || `Posición ${index + 1}`;
    },
    getPriorityColor(index) {
      const colors = ['success', 'warning', 'info'];
      return colors[index] || 'grey';
    },
    onDragStart(event, index) {
      this.draggingIndex = index;
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/html', event.target.innerHTML);
      event.target.style.opacity = '0.5';
      console.log('🔵 Drag start:', index);
    },
    onDragOver(event, index) {
      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';
    },
    onDragEnter(event, index) {
      if (this.draggingIndex !== index) {
        this.dragOverIndex = index;
      }
    },
    onDragLeave(event) {
      // Solo limpiar si realmente salimos del elemento
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.dragOverIndex = null;
      }
    },
    onDrop(event, dropIndex) {
      event.preventDefault();
      
      const dragIndex = this.draggingIndex;
            
      if (dragIndex !== null && dragIndex !== dropIndex) {
        // Remover el elemento de la posición original
        const draggedItem = this.prioritizedQuotations[dragIndex];
        
        // Crear nuevo array con el orden correcto
        const newArray = [...this.prioritizedQuotations];
        newArray.splice(dragIndex, 1);
        newArray.splice(dropIndex, 0, draggedItem);
        
        this.prioritizedQuotations = newArray;
        
      }
      
      this.dragOverIndex = null;
    },
    onDragEnd(event) {
      event.target.style.opacity = '1';
      this.draggingIndex = null;
      this.dragOverIndex = null;
    },
  },
};
</script>

<style scoped>
.draggable-card {
  cursor: move;
  transition: all 0.3s ease;
  user-select: none;
}

.draggable-card.dragging {
  opacity: 0.5;
  transform: scale(0.95);
}

.draggable-card.drag-over {
  border: 2px dashed #4CAF50;
  background-color: rgba(76, 175, 80, 0.1);
  transform: scale(1.02);
}

.drag-handle {
  cursor: grab;
  color: #999;
}

.drag-handle:active {
  cursor: grabbing;
}

.draggable-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
</style>
